<slm-dialog-container
  [title]="data?.title"
  [buttons]="buttons"
  class="w-max-100p block"
  (fireEvent)="buttonEvent($event.event)"
>
  <h5 *ngIf="!data.isHtml">{{ data.label | translate: data.labelParams }}</h5>
  <slm-template-presenter *ngIf="data.isHtml" [template]="label"></slm-template-presenter>
</slm-dialog-container>
